import { privacyPolicyMarkdown } from "@canucci/base";
import { Container } from "@mantine/core";
import { StyledMarkdown } from "./StyledMarkdown";

export function PrivacyPolicyPage({
  accentHorizontalRules = false,
  accentDocumentTitle = false,
  accentSectionDividers = false,
  accentEmailLinks = false,
}: {
  accentHorizontalRules?: boolean;
  accentDocumentTitle?: boolean;
  accentSectionDividers?: boolean;
  accentEmailLinks?: boolean;
}) {
  return (
    <Container maw="48rem" py="xl">
      <StyledMarkdown
        content={privacyPolicyMarkdown}
        accentHorizontalRules={accentHorizontalRules}
        accentDocumentTitle={accentDocumentTitle}
        accentSectionDividers={accentSectionDividers}
        accentEmailLinks={accentEmailLinks}
      />
    </Container>
  );
}
